// extracted by mini-css-extract-plugin
export default {"search":"Landing_search__n985B"};